const RowsPerPage = 25;

export { RowsPerPage };
